import { ArrowDownRight, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from 'src/components/ui/button';
import { useTxContext } from '../TxContext';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'src/components/ui/tooltip';
import { numberWithCommas } from 'src/utils/number';
import { getDate, getSystemTZ, getUTCDate } from 'src/utils/date';

export function TxHeader() {
  const { transaction } = useTxContext();

  const direction = transaction.direction;
  const hash = transaction.id;
  const block = transaction.block.toString();
  const fee = (transaction.txfee / 100000000).toFixed(8);
  const timestamp = transaction.timestamp.toString();

  return (
    <div className="flex flex-col justify-between gap-3 border-b border-muted-100 p-4 text-xs md:flex-row md:items-center">
      <div className="flex items-center gap-3">
        {direction && (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <div className="relative flex h-10 w-10 items-center justify-center">
                  <div className="absolute inset-0 rounded-full border border-muted-50"></div>
                  <div
                    className={`flex h-7 w-7 items-center justify-center rounded-full ${
                      direction === 'outgoing'
                        ? 'bg-destructive'
                        : 'bg-emerald-500'
                    }`}
                  >
                    {direction === 'outgoing' ? (
                      <ArrowUpRight className="h-4 w-4 text-white" />
                    ) : (
                      <ArrowDownRight className="h-4 w-4 text-white" />
                    )}
                  </div>
                </div>
              </TooltipTrigger>
              <TooltipContent>
                <p>
                  {`${direction.charAt(0).toUpperCase()}${direction.slice(1)} Tx`}
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
        <Button
          asChild
          variant="link"
          size="sm"
          className="overflow-hidden text-ellipsis whitespace-nowrap p-0 text-xs text-amber-600/80"
        >
          <Link to={`/bitcoin/transaction/${hash}`}>{hash}</Link>
        </Button>
      </div>
      <div className="text-muted-foreground">
        Block: {numberWithCommas(Number(block))}
      </div>
      <div className="text-muted-foreground">
        Fee: {numberWithCommas(Number(fee), 8)} BTC
      </div>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger className="text-muted-foreground">
            {getDate(timestamp)}
            {getSystemTZ()}
          </TooltipTrigger>
          <TooltipContent>
            <p>{`${getUTCDate(timestamp)} UTC`}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
